import { ReactElement } from 'react';

import { Visit, VisitFinishApprovedCommand, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, FullscreenSpinner } from '@dreryk/react-components';

import { visitDetailsTranslationKeys, visitTranslationKeys } from '../../../../translations';
import { useVisitCommand } from '../../../../visit/form/actionBar/shared/confirmVisit.hooks';
import { useVisitPushBack } from '../../../../visit/form/visitForm.hooks';
import { mapVisitToVisitFormBean } from '../../../../visit/form/visitForm.utils';
import { VisitId } from '../../PrescriptionIssuingPanel.types';

type ConfirmPrescriptionVisitActionChildrenRenderProps = {
   readonly confirmVisit: VoidFunction;
};

type ConfirmPrescriptionVisitActionProps = {
   readonly visitId: VisitId;
   readonly children: (renderProps: ConfirmPrescriptionVisitActionChildrenRenderProps) => ReactElement;
};

export const ConfirmPrescriptionVisitAction = (props: ConfirmPrescriptionVisitActionProps): ReactElement => {
   const pushBack = useVisitPushBack();

   const { data: visit } = useCqrsFind<Visit | null>(() => {
      const query = new VisitQuery();
      query.visitId = props.visitId;
      return query;
   });

   const { executeAsync: executeConfirmVisit, loading } = useVisitCommand(VisitFinishApprovedCommand, {
      visitId: props.visitId,
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(visitDetailsTranslationKeys.visitConfirmed);
         pushBack();
      },
   });

   const confirmVisit = (): void => {
      if (!visit) {
         return;
      }
      executeConfirmVisit(mapVisitToVisitFormBean(visit));
   };

   return (
      <>
         {props.children({ confirmVisit: confirmVisit })}
         {loading ? <FullscreenSpinner label={visitTranslationKeys.confirmingVisit} /> : null}
      </>
   );
};
